import { Box, Stack } from '@dtx-company/design-system/src'
import { CSSTransition } from 'react-transition-group'
import { CodePreview } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/CodePreview/CodePreview'
import { FC } from 'react'
import { FormActionButtons } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/FormActionButtons/FormActionButtons'
import { GeneratorHeading } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/GeneratorHeading/GeneratorHeading'
import { NAV_V2_HEIGHT } from '@dtx-company/true-common/src/constants/layout'
import { ScrollableContainer } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/ScrollableContainer/ScrollableContainer'
import { TRANSITION_DURATION } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/LoggedOutCodeGenerator.constants'
import { useGlobalServices } from '@dtx-company/app/shared/common/src/hooks/useGlobalServices'
import { useLoggedOutGeneratorMobileTransitionStyles } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/hooks/useLoggedOutGeneratorMobileTransitionStyles'
import { useSelector } from '@xstate/react'

export const ScrollableLOCGenerator: FC = () => {
  //this component is used only on mobile
  const { locgService } = useGlobalServices()
  const displayFormActionButtons = useSelector(locgService, state => !state.matches('auth'))
  const { generatorHeadingRef, generatorHeadingTransitionsSx, codePreviewTransitionsSx } =
    useLoggedOutGeneratorMobileTransitionStyles()

  return (
    <Stack
      sx={theme => ({
        height: `calc(100vh - ${NAV_V2_HEIGHT}px) `,
        width: '100%',
        borderBottom: {
          md: `1px solid ${theme.palette.border.outline}`,
          lg: 'unset'
        },
        maxHeight: {
          md: theme.spacing(209)
        },
        minHeight: {
          md: theme.spacing(150)
        },
        ...generatorHeadingTransitionsSx
      })}
    >
      <CSSTransition in={false} timeout={TRANSITION_DURATION} classNames="generator-heading">
        <GeneratorHeading ref={generatorHeadingRef} />
      </CSSTransition>

      <Stack
        direction={{
          xs: 'column',
          md: 'row'
        }}
        sx={{
          width: '100%',
          flex: 1,
          overflow: 'hidden',
          ...codePreviewTransitionsSx
        }}
      >
        <CSSTransition
          in={displayFormActionButtons}
          timeout={TRANSITION_DURATION}
          classNames="code-preview"
        >
          <Box
            sx={{
              flex: {
                md: 0.85,
                lg: 1
              }
            }}
          >
            <CodePreview />
          </Box>
        </CSSTransition>

        <Box
          sx={{
            position: 'relative',
            flex: {
              xs: 1,
              md: 1.5,
              lg: 1
            },
            pb: { xs: 6, md: 0 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            overflow: 'hidden',
            height: '100%'
          }}
        >
          <ScrollableContainer />
          {displayFormActionButtons && <FormActionButtons />}
        </Box>
      </Stack>
    </Stack>
  )
}
